import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface YoutubeVideoHeadlineModel extends BaseModel {
  variables?: { [key: string]: string } | YoutubeVideoHeadlineVariables;
}

export interface YoutubeVideoHeadlineVariables {
  YoutubeVideoHeadline: string;
}

export class YoutubeVideoHeadlineInitVariables implements YoutubeVideoHeadlineVariables {
  YoutubeVideoHeadline = '';
}

export class YoutubeVideoHeadlineInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new YoutubeVideoHeadlineInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
